import React from 'react';
import { CountryPageProps } from './interfaces/ComponentProps';

function LegacyManualRedirect({ country }: CountryPageProps) {
  React.useEffect(() => {
    const currentPath = process.env.REACT_APP_SiteUrl ?? "";

    window.location.replace(`${currentPath}/${country}/onboard/manual`);
  }, [country]);

  return null;
}

export default LegacyManualRedirect;
